import TasksModule from '@modules/TasksModule';

const useTaskActions = (taskId: string) => {
  // accepts channel (picks up, accepts offer, etc)
  const handleAccept = () => {
    TasksModule.actionTask(taskId, 'accept');
  };

  // stops channel (hangs up, etc)
  const handleReject = () => {
    TasksModule.actionTask(taskId, 'reject');
  };

  // completes task
  const handleComplete = () => {
    TasksModule.actionTask(taskId, 'complete');
  };

  const handleResume = () => {
    TasksModule.actionTask(taskId, 'unhold');
  };
  return { handleAccept, handleReject, handleComplete, handleResume };
};

export default useTaskActions;
